import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { useAccordionAnimation } from '../../hooks/useAccordionAnimation';

const HBNewTableExpandedRow = ({
    item,
    colSpan,
    renderComponent,
    isRowExpanded
}) => {
    const animation = useAccordionAnimation();
    const actualComponent = renderComponent(item);
    return (
        <StyledTr>
            <StyledTd colSpan={colSpan}>
                <AnimatePresence initial={false}>
                    {isRowExpanded && (
                        <>
                            <MotionWrapper {...animation}>
                                {actualComponent}
                            </MotionWrapper>
                            <MotionWrapperHidden {...animation}>
                                {actualComponent}
                            </MotionWrapperHidden>
                        </>
                    )}
                </AnimatePresence>
            </StyledTd>
        </StyledTr>
    );
};

export default HBNewTableExpandedRow;

// --- Styles ---

const StyledTr = styled.tr``;

const StyledTd = styled.td`
    padding: 0;
`;

const MotionWrapper = styled(motion.div)`
    position: absolute;
    left: 0;
    width: 100%;
`;

const MotionWrapperHidden = styled(motion.div)`
    opacity: 0;
    pointer-events: none;
`;
